<template>
  <div class="commission-rank" ref="container">
    <div class="header">
      <div class="title">审核状态</div>
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-around">
        <div
          class="item"
          :class="active === index ? 'font-color-red' : ''"
          v-for="(item, index) in navList"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="list">
        <block>
          <div
            class="content-box"
            v-for="(item, index) in sertificationList"
            :key="index"
          >
            <div class="time-box">
              <div>提交时间：</div>
              <div>{{ item.add_time | formatDate }}</div>
            </div>
            <div class="content-type">
              <div>申请的类型：</div>
              <div v-if="item.type == 1">企业认证</div>
              <div v-else>个人认证</div>
            </div>
            <div class="result-type">
              <div>审核结果：</div>
              <div v-if="item.isAgree == 1">
                <el-button type="success" size="mini">审核通过</el-button>
              </div>
              <div v-else-if="item.isAgree == 2">
                <el-button type="primary" size="mini">审核中</el-button>
              </div>
              <div v-else>
                <el-button
                  type="info"
                  size="mini"
                  v-if="item.type == 1"
                  @click="commitCompany"
                  >重新提交</el-button
                >
                <el-button type="info" size="mini" @click="commitPatient" v-else
                  >重新提交</el-button
                >
                <el-button type="danger" size="mini">审核不通过</el-button>
              </div>
            </div>
            <div class="time-box judge-reason" v-if="item.isAgree == 3">
              <div>拒绝原因：</div>
              <div>{{ item.remark }}</div>
              <!-- <div>审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过审核不通过</div> -->
            </div>
          </div>
        </block>
      </div>
    </div>
    <!-- Matomo Image Tracker-->
    <img
      src="https://piwik.sosyao.com/matomo.php?idsite=15&amp;rec=1"
      style="border:0"
      alt=""
    />
    <!-- End Matomo -->
  </div>
</template>
<style scoped>
.commission-rank .header {
  background: url("../../../assets/moblie/images/rushBuy.jpg") no-repeat;
  width: 100%;
  height: 2.4rem;
  background-size: 100% 100%;
  position: relative;
  z-index: -1;
}
.title {
  text-align: center;
  line-height: 1.6rem;
  font-size: 16px;
  color: #fff;
  font-weight: 700;
  letter-spacing: 4px;
}
.commission-rank .header .rank {
  font-size: 0.33rem;
  color: #fff;
  position: absolute;
  top: 1.6rem;
  left: 0.48rem;
}
.content-box {
  margin: 0.2rem 0;
  padding-bottom: 0.25rem;
  border-bottom: 1px dashed #999;
  font-size: 16px;
}
.content-box:last-child {
  border-bottom: 0;
}
.content-box > div {
  line-height: 36px;
}
.content-box .time-box,
.content-box .content-type,
.content-box .result-type {
  display: flex;
  justify-content: space-between;
}
.content-box .judge-reason > div:first-child {
  color: #e93323;
}
.content-box .judge-reason > div:last-child {
  width: 70%;
  font-size: 16px;
  line-height: 22px;
  padding-top: 0.125rem;
  color: #555;
  text-align: right;
}
.commission-rank .header .rank .num {
  font-size: 0.51rem;
  font-weight: bold;
  margin: 0 0.1rem;
}
.commission-rank .wrapper {
  width: 7.1rem;
  background-color: #fff;
  border-radius: 0.2rem;
  margin: -0.76rem auto 0 auto;
}
.commission-rank .wrapper .nav {
  height: 0.99rem;
  border-bottom: 0.025rem solid #f3f3f3;
  font-size: 0.3rem;
  font-weight: bold;
  color: #999;
  line-height: 0.99rem;
}
.commission-rank .wrapper .nav .item.font-color-red {
  border-bottom: 0.04rem solid #e93323;
}
.commission-rank .wrapper .list {
  padding: 0 0.3rem;
}
.commission-rank .wrapper .list .item {
  border-bottom: 1px solid #f3f3f3;
  height: 1.01rem;
  font-size: 0.28rem;
}
.commission-rank .wrapper .list .item .num {
  color: #666;
  width: 0.7rem;
}
.commission-rank .wrapper .list .item .num img {
  width: 0.34rem;
  height: 0.4rem;
  display: block;
}
.commission-rank .wrapper .list .item .picTxt {
  width: 3.5rem;
}
.commission-rank .wrapper .list .item .picTxt .pictrue {
  width: 0.68rem;
  height: 0.68rem;
}
.commission-rank .wrapper .list .item .picTxt .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 50%;
}
.commission-rank .wrapper .list .item .picTxt .text {
  width: 2.62rem;
  color: #333;
}
.commission-rank .wrapper .list .item .people {
  width: 1.75rem;
  text-align: right;
}
</style>
<script>
import { getCondition } from "@api/user";
import { mapGetters } from "vuex";
const NAME = "verifyStatus";
export default {
  name: NAME,
  data: function() {
    return {
      navList: ["资质审核"], // 处方审核
      active: 0,
      sertificationList: [], // 资质列表
      page: 1,
      loading: false,
      loadend: false,
      is_certification: ""
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted: function() {
    this.getAllList();
  },
  methods: {
    // switchTap: function(index) {
    //   this.active = index;
    // },
    getAllList: function() {
      getCondition({
        page: this.page
      })
        .then(res => {
          this.sertificationList = res.data.sertification;
        })
        .catch(() => {});
    },
    commitCompany() {
      // 避免重复提交
      if (this.userInfo.is_certification == 2) {
        this.$dialog.toast({ mes: "您提交的资质已在审核中，请勿重复提交" });
        return;
      } else if (this.userInfo.is_certification == 1) {
        this.$dialog.toast({ mes: "您提交的资质已认证通过，可直接购买药品" });
        return;
      }
      this.$router.push({
        path: "/user/authenticate/company"
      });
    },
    commitPatient() {
      // 避免重复提交
      if (this.userInfo.is_certification == 2) {
        this.$dialog.toast({ mes: "您提交的资质已在审核中，请勿重复提交" });
        return;
      } else if (this.userInfo.is_certification == 1) {
        this.$dialog.toast({ mes: "您提交的资质已认证通过，可直接购买药品" });
        return;
      }
      this.$router.push({
        path: "/user/authenticate/patient"
      });
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  }
};
</script>
